import { useMemo } from "react";

import { useGetExperiencesList } from "@src/api/experiences-list/get-experiences-list";
import { useGetOrg } from "@src/api/organizations/get-organization";

export const useIsTestLimitHit = () => {
  const experiencesList = useGetExperiencesList({ category: "experiment" });
  const org = useGetOrg();

  return useMemo(() => {
    const maxTests: number = org.data.org.configurations.find(
      (c) => c.key === "concurrent_tests"
    )?.value;
    const activeTestsCount =
      experiencesList.data?.experiencesList.filter(
        (ex) => ex.status === "started"
      ).length || 0;
    return activeTestsCount >= maxTests;
  }, [experiencesList]);
};
